export default __webpack_public_path__ + "static/Leisha Watson-8748c900f447f8a4e1c35a634c99aaf4.jpg";